module.exports = __webpack_public_path__ + "media/ca_slide7_audio.d39dbcff.mp4";